import React, { createContext, useContext } from "react";
import { useEditor, useNode } from "@craftjs/core"; // We still need useNode for connectors.connect on the parent
import { WebsiteContext } from "@/pages/website/WebsiteProvider";

export const RepeatContext = createContext<any>({});

const Repeater = ({ children }) => {
  const { connectors } = useNode();
  const { query } = useEditor();
  const websiteContext = useContext(WebsiteContext);
  const isEditorEnabled = query.getOptions().enabled;

  if (!children) {
    return (
      <div ref={(ref) => connectors.connect(ref)} style={{ border: "2px dashed blue", padding: "20px", textAlign: "center" }}>
        Drop a component here to repeat it based on data.
      </div>
    );
  }

  if (isEditorEnabled && !websiteContext?.website?.settings?.links?.value) {
    return <div style={{ border: "2px dashed blue", padding: "20px", textAlign: "center" }}>No hay enlaces disponibles</div>;
  }

  return (
    <div ref={(ref) => connectors.connect(ref)}>
      {websiteContext.website?.settings?.links?.value.map((item) => (
        <RepeatContext.Provider value={{ ...item }}>{React.cloneElement(children)}</RepeatContext.Provider>
      ))}
    </div>
  );
};

Repeater.craft = {
  displayName: "Repetidor",
  props: {
    data: [],
  },
  related: {
    settings: () => (
      <div>
        <h3>Repeater Settings</h3>
        <p>Manage the data array that drives the repetition here.</p>
      </div>
    ),
  },
  isDroppable: true,
};

export default Repeater;
